const configsStaging = 'https://beta-sb-app-configs-vlwut6qbsq-ew.a.run.app';
const configsLive = 'https://sb-app-configs-jtdpxp3bfa-ew.a.run.app';
export const configsUrl = () => {
	return [true, 'true'].includes(process['env'].PROD_ENV) ? configsLive : configsStaging;
};
export const runModeling = async (id, token) => {
	return await fetch(configsUrl() + `/run-ingest?cid=${id}&token=${token}`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		}
	}).then(async (res) => {
		const json = await res.json();
		if (res.ok) {
			return json;
		} else {
			throw new Error(json.detail);
		}
	});
};
export const getStatus = async (id, token, gridId) => {
	let apiUrl = configsUrl() + '/live?cid=' + id + '&token=' + token;
	if (gridId) {
		apiUrl += '&grid_id=' + gridId;
	}
	const res = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	}).then((res) => res.json());
	return res;
};

export const getGridList = async (id, token) => {
	const res = await fetch(configsUrl() + '/configs/homepage/list/' + id + '?token=' + token);
	const json = await res.json();
	return json;
};
